import { render, staticRenderFns } from "./images-wrapper.vue?vue&type=template&id=7583c57f&scoped=true&"
import script from "./images-wrapper.vue?vue&type=script&lang=js&"
export * from "./images-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./images-wrapper.vue?vue&type=style&index=0&id=7583c57f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7583c57f",
  null
  
)

export default component.exports